import React from "react";
import AuthLayout from "@shared/hoc/auth/AuthLayout";
import LoginForm from "@shared/hoc/auth/component/LoginForm";

const Login = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 px-4 sm:px-6">
      <div className="flex h-auto max-h-[700px] w-full  max-w-5xl flex-col overflow-hidden rounded-3xl bg-white shadow-lg md:h-[calc(100vh-20px)] md:flex-row">
        <AuthLayout />
        <LoginForm />
      </div>
    </div>
  );
};

export default Login;
